import { useRef, useState } from 'react';
import { IonModal, IonButton, IonInput, IonIcon, IonText, IonImg } from '@ionic/react';
import { airplane, close, arrowBack } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import axios from "axios";
import Loading from '../../Loading';
import './FlightAirport.css';
import warningSign from '../../../assets/images/warning.svg';

interface Props {
    type: string,
    section: string,
    flightAirportParentCallback: Function,
    multipleIndex?: number,
    itemValue?: string
}

const FlightAirportModal = (props: Props) => {
    // ============================================================================
    //                                  States  
    // ============================================================================
    const [state, setState] = useState({
        itemValue: props.type === 'origin' ? 'مبدا خود را انتخاب کنید' : 'مقصد خود را انتخاب کنید',
        showFlightAirportModal: false,
        showFlightAirportPreDefines: false,
        flightAirportPreDefinesDomestic: [],
        flightAirportPreDefinesinternational: [],
        flightAirportAutoFillItems: [],
        errorMessage: ''
    });
    const [loading, setLoading] = useState(false);
    // ============================================================================
    //                                 API Call 
    // ============================================================================
    const preDefinesApi = Constants.api.flightsPredefines;
    const autoFillApi = Constants.api.flightsAirports;

    const flightAirportPreDefines = async () => {
        setLoading(true);
        setState({ ...state, showFlightAirportModal: true });
        try {
            const results = await axios.post(preDefinesApi, {
                section: props.section,
                type: props.type === 'origin' ? 'departure' : 'arrival'
            }, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
            });
            setState({ ...state, showFlightAirportModal: true, showFlightAirportPreDefines: true, flightAirportPreDefinesDomestic: results.data.items.domestic, flightAirportPreDefinesinternational: results.data.items.international });
            setLoading(false);
        } catch (error) {
            console.log(error);
            setState({ ...state, showFlightAirportModal: true, flightAirportPreDefinesDomestic: [], flightAirportPreDefinesinternational: [], errorMessage: '' });
            setLoading(false);
        }
    }

    const cancelToken = useRef() as any;
    const flightAirportAutoFill = async (e: any) => {
        const searchKeyword = e.target.value
        if (!searchKeyword) {
            setState({ ...state, showFlightAirportPreDefines: true, flightAirportAutoFillItems: [], errorMessage: '' });
            setLoading(false);
            return;
        }
        if (searchKeyword.length > 2) {
            setLoading(true);
            setState({ ...state, showFlightAirportPreDefines: false });
            if (typeof cancelToken.current != typeof undefined) {
                cancelToken.current.cancel("Operation canceled due to new request.")
            }
            cancelToken.current = axios.CancelToken.source();
            try {
                const results = await axios.get(
                    autoFillApi + searchKeyword,
                    { cancelToken: cancelToken.current.token }
                )
                if (results.data.items.length) {
                    const autoFillGroup = results.data.items.reduce((autoFillGroupCats: any, item: any) => {
                        if (!autoFillGroupCats[item.city_en]) autoFillGroupCats[item.city_en] = [];
                        autoFillGroupCats[item.city_en].push(item);
                        return autoFillGroupCats;
                    }, {});
                    setState({ ...state, showFlightAirportPreDefines: false, flightAirportAutoFillItems: Object.values(autoFillGroup), errorMessage: '' });
                    setLoading(false);
                } else {
                    setState({ ...state, showFlightAirportPreDefines: false, flightAirportAutoFillItems: [], errorMessage: 'نتیجه ای یافت نشد!' });
                    setLoading(false);
                }
            } catch (error) {
                console.log(error)
                setState({ ...state, showFlightAirportPreDefines: false, flightAirportAutoFillItems: [], errorMessage: '' });
                setLoading(false);
            }
        } else {
            setState({ ...state, showFlightAirportPreDefines: true, flightAirportAutoFillItems: [], errorMessage: '' });
            setLoading(false);
            return;
        }
    }
    // ============================================================================
    //                              Custome Functions 
    // ============================================================================
    const autoFillItemOnClickFunctions = (item: any, is_all = false) => {
        let myItemValue = JSON.parse(item);
        myItemValue.is_all = is_all;
        if (is_all) {
            myItemValue.title = myItemValue.country_fa + ' - ' + myItemValue.city_fa + ' - همه فرودگاه ها ';
            myItemValue.code = myItemValue.city_code;
        } else {
            myItemValue.code = myItemValue.airport_code;
        }
        setState({ ...state, itemValue: myItemValue.title, showFlightAirportModal: false, flightAirportAutoFillItems: [] });
        props.flightAirportParentCallback(JSON.stringify(myItemValue));
    }
    const predefinedItemOnClickFunctions = (item: any) => {
        let myItemValue = JSON.parse(item);
        myItemValue.city_fa = myItemValue.title;
        setState({ ...state, itemValue: myItemValue.title, showFlightAirportModal: false, flightAirportAutoFillItems: [] });
        myItemValue.multipleIndex = props.multipleIndex;
        props.flightAirportParentCallback(JSON.stringify(myItemValue));
    }
    const openModal = () => {
        flightAirportPreDefines();
    }
    // ============================================================================
    //                                  Map Items 
    // ============================================================================
    const flightAirportPreDefinesDomesticList = state.flightAirportPreDefinesDomestic.map((item: any, index) =>
        <div className="flight-airport-modal-item" key={'index' + index} onClick={() => predefinedItemOnClickFunctions(JSON.stringify(item))}>
            <IonIcon icon={airplane} className="flight-airport-modal-icon" />
            <span>{item.title}</span>
        </div>
    )

    const flightAirportPreDefinesinternationalList = state.flightAirportPreDefinesinternational.map((item: any, index) =>
        <div className="flight-airport-modal-item" key={'index' + index} onClick={() => predefinedItemOnClickFunctions(JSON.stringify(item))}>
            <IonIcon icon={airplane} className="flight-airport-modal-icon" />
            <span>{item.title}</span>
        </div>
    )
    const flightAirportAutoFillItemsList = state.flightAirportAutoFillItems.map((groupItem: any, groupIndex) =>
        <div className="auto-fill-item" key={groupIndex}>
            <IonIcon icon={airplane} />
            <b onClick={() => autoFillItemOnClickFunctions(JSON.stringify(groupItem[0]), true)}>
                {groupItem[0].country_fa + ' - ' + groupItem[0].city_fa + ' - همه فرودگاه ها '}
            </b>
            <ul>
                {groupItem.map((childItem: any, childIndex: number) =>
                    <li key={childIndex} onClick={() => autoFillItemOnClickFunctions(JSON.stringify(childItem))}>
                        <IonIcon icon={arrowBack} />
                        <span>{childItem.airport_fa}</span>
                        <span>{childItem.airport_code}</span>
                        <span>{childItem.airport_en}</span>
                    </li>
                )}
            </ul>
        </div>
    )
    // ============================================================================
    //                                  Render 
    // ============================================================================
    return (
        <div>
            <IonModal isOpen={state.showFlightAirportModal} onDidDismiss={() => setState({ ...state, showFlightAirportModal: false, flightAirportAutoFillItems: [] })} mode="ios" cssClass="flight-airport-modal">
                <div className="flight-airport-modal-content">
                    <h3 className="flight-airport-modal-title">
                        {props.type === 'origin' ? 'مبدا مورد نظر خود را انتخاب کنید' : 'مقصد مورد نظر خود را انتخاب کنید'}
                        <IonIcon icon={close} onClick={() => setState({ ...state, showFlightAirportModal: false, flightAirportAutoFillItems: [] })} />
                    </h3>
                    <div className="flight-airport-modal-search">
                        <IonInput type="text" placeholder="جستجو کنید ..." onIonChange={flightAirportAutoFill} />
                    </div>
                    <div className="flight-airport-modal-items">
                        {state.errorMessage.trim() !== '' ? (
                            <div className="box-error">
                                <IonImg src={warningSign} />
                                <p>{state.errorMessage}</p>
                            </div>
                        ) : loading ? (
                            <Loading />
                        ) : (
                            flightAirportAutoFillItemsList
                        )}
                        {state.showFlightAirportPreDefines && flightAirportPreDefinesDomesticList.length ? (
                            <>
                                <h6>داخلی</h6>
                                {flightAirportPreDefinesDomesticList}
                            </>
                        ) : (
                            null
                        )}
                        {state.showFlightAirportPreDefines && flightAirportPreDefinesinternationalList.length ? (
                            <>
                                <h6>خارجی</h6>
                                {flightAirportPreDefinesinternationalList}
                            </>
                        ) : (
                            null
                        )}
                    </div>
                </div>
                <div>
                    <IonButton color="warning" expand="block" onClick={() => setState({ ...state, showFlightAirportModal: false, flightAirportAutoFillItems: [] })} className="flight-airport-modal-close-btn">بستن</IonButton>
                </div>
            </IonModal>
            <IonText onClick={openModal}>
                {props.itemValue ?
                    props.itemValue
                    :
                    state.itemValue
                }
            </IonText>
        </div>
    );
};
export default FlightAirportModal;